import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { getCookie } from '../utils/get-cookie';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Recupera o token do cookie
    const token = getCookie('token');

    // Se o token não existir, redireciona para a página techfinance
    if (!token) {
      window.location.href = 'https://app.techfinance.com.br';
      // Para interromper a requisição, podemos retornar um Observable vazio ou uma falha
      return new Observable();
    }

    // Se o token existir, modifica a requisição e adiciona o token no cabeçalho Authorization
    const clonedRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });

    // Continua a requisição
    return next.handle(clonedRequest);
  }
}
